"use strict";

import angular from "angular";

import template from "./confetti-animation.component.html";

class ConfettiAnimation {
    constructor() {}
    $onInit() {
        this.start();
    }
    $onChanges(changes) {}
    start() {}
}

ConfettiAnimation.$inject = [];

const name = "confettiAnimationComponent";
const def = {
    bindings: {
        trigger: "<"
    },
    controller: ConfettiAnimation,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
